// react
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { push } from 'connected-react-router'
// mui
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
// comp
import { Layout, SelectBox, PrimaryButton } from '../components'
// firebase
import { db, functions, FirebaseTimestamp } from '../firebase'
// Assets
import MATTERS from '../assets/matters.json'

const ContactsRef = db.collection('contacts')

const Contact = () => {

    const dispatch = useDispatch()

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [tel, setTel] = useState('')
    const [matter, setMatter] = useState('')
    const [matters] = useState(MATTERS.list)
    const [inquery, setInquery] = useState('')

    const saveContact = (name, email, tel, matter, inquery) => {
        if (name === '' || email === '' || matter === '' || inquery === '' ) {
            alert('未入力の必須項目があります')
            return false
        }
        // email validation
        const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (!regexEmail.test(email)) {
            alert('メールアドレスの形式が不正です。もう1度お試しください。')
            return false
        }
        // 電話番号Validation
        if (tel) {
            const regexTel = /^[0-9]{10,11}$/
            if (!regexTel.test(tel)) {
                alert('電話番号は10桁または11桁の数字で入力してください（ハイフン不要）')
                return false
            }
        }
        if (window.confirm('送信します。よろしいですか？')) {
            // 保存データのセット
            const timestamp = FirebaseTimestamp.now()
            const newContactId = ContactsRef.doc().id
            const data = {
                id: newContactId,
                name, email, tel, matter, inquery,
                isOpen: false,
                isReply: false,
                created_at: timestamp
            }
            const mailData = {
                to: email,
                subject: '【Weth-Store】お問い合わせを受け付けしました',
                text: `
下記のお問い合わせを受け付けました。

お名前：
${name}

お問い合わせ内容：
${inquery}

回答までいましばらくお待ち下さい。
`
            }
            const sendMail = functions.httpsCallable('sendMail')
            // Firestoreに保存
            ContactsRef.doc(newContactId).set(data)
                       .then(() => {
                           // メール送信
                           sendMail(mailData)
                           // 画面遷移
                           dispatch(push('/contact/complete'))
                       })
        } else {
            return false;
        }
    }

    return (
        <Layout>
            <div className='spacer-100' />
            <h1 style={{textAlign: 'center'}}>お問い合わせ</h1>
            <div className='spacer-50' />

            <InputWrapper>
                <TextField 
                    label={'お名前'} type={'text'} required={true} variant='filled'
                    value={name} onChange={e=>setName(e.target.value)} style={{marginBottom: '10px'}}
                />
                <TextField 
                    label={'メールアドレス'} type={'email'} required={true} fullWidth={true} variant='filled'
                    value={email} onChange={e=>setEmail(e.target.value)} style={{marginBottom: '10px'}}
                />
                <TextField 
                    label={'電話番号'} type={'tel'} required={false} fullWidth={true} variant='filled'
                    value={tel} onChange={e=>setTel(e.target.value)} style={{marginBottom: '10px'}}
                />
                <SelectBox
                    label={'問い合わせの種類'} required={true} select={setMatter} value={matter} options={matters} style={{marginBottom: '10px'}}
                />
                 <div className='spacer-25' />
                <TextField 
                    label={'お問い合わせ内容'} type={'text'} multiline={true} rows={10} required={true} fullWidth={true} variant='filled'
                    value={inquery} onChange={e=>setInquery(e.target.value)}
                />
            </InputWrapper>

            <div className='spacer-50' />
            <div style={{textAlign: 'center'}}>
                <PrimaryButton 
                    label={'送信する'} 
                    operation={()=>{
                        saveContact(name, email, tel, matter, inquery)
                    }} 
                />
                <div className='spacer-50' />
                <Button onClick={()=>dispatch(push('/'))}>ホームに戻る</Button>
            </div>
            <div className='spacer-100' />
        </Layout>
    )
}
export default Contact

const InputWrapper = styled.div`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`